export default function getEnvironment() {
  const hostname = window.location.hostname;
  if (hostname === 'customer.joulepoint.com') {
    return 'production';
  } else if (hostname === 'customer-test.joulepoint.com') {
    return 'test';
  } else {
    return 'development';
  }
}
